<template>
  <div id="inspection-form">
    <div class="main">
      <div class="title">
        <img src="../../assets/images/LTicon.png" alt="" />
        <span>监测回路</span>
      </div>
      <div class="content">
        <div class="query-form">
          <el-form class="form" ref="form" :inline="true" :model="requestParam">
            <!-- <el-form-item label="变配电站：">
              <el-select v-model="requestParam.stationId" :popper-append-to-body="false" clearable placeholder="请选择电站">
                <el-option v-for="item in stationData" :key="item.id" :label="item.stationName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="回路名称：">
              <el-input v-model="requestParam.loopName" placeholder="请输入回路名称" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="回路编号：">
              <el-input v-model="requestParam.loopNumber" placeholder="请输入回路编号" clearable>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="query-button">
            <el-button type="primary" icon="el-icon-search" @click="formQuery">查询</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="createInspection">新建回路</el-button>
          </div>
        </div>

        <el-table v-loading='dataLoading' element-loading-text="加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)" :cell-style="{ color: '#AED6FF', fontSize: '12px' }"
          :header-cell-style="{ color: '#e8f4ff', fontSize: '14px' }" class="table" :data="tableData" default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <!-- 
            绑定id为唯一值
             row-key="id"

            -->
          <div slot="empty">
            <div v-if="tableData.length == 0">
              <div class="empty-data-view">
                <div class="tableText">
                  {{ dataLoading ? '' : '暂无数据' }}
                </div>
              </div>
            </div>
          </div>
          <el-table-column align="center" label="序号" type="index" :index="getIndex" width="60px">
          </el-table-column>
          <el-table-column align="center" prop="stationIdDesc" label="电站名称">
          </el-table-column>
          <el-table-column align="center" prop="loopName" label="回路名称">
          </el-table-column>
          <el-table-column align="center" prop="loopNumber" label="回路编号">
          </el-table-column>
          <el-table-column align="center" prop="lineFlage" label="是否进线">
            <template slot-scope="scope">
              {{ scope.row.lineFlage == 1 ? '是' : scope.row.lineFlage == 2 ? '否' : '-' }}
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="deviceName" label="仪表名称">
          </el-table-column>
          <el-table-column align="center" prop="deviceNumber" label="仪表编号">
          </el-table-column> -->
          <el-table-column align="center" prop="data" fixed="right" label="操作" width="180px">
            <template slot-scope="scope">
              <el-button @click="editDialog(scope.row)" type="text">编辑</el-button><span>|</span>
              <el-button @click="lookDialog(scope.row)" type="text">查看</el-button><span>|</span>
              <el-button @click="deleteDialog(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <button class="home-page" @click="homePage">首页</button>
          <el-pagination :current-page="requestParam.pageNum" :page-sizes="[10, 20, 30, 40]"
            layout="prev, pager, next, sizes,slot" prev-text="上一页" next-text="下一页" :total="total" background
            @size-change="changeSize" @current-change="changeCurrent">
          </el-pagination>
          <button class="tail-page" @click="tailPage">尾页</button>
          <div class="jump-pagination">
            <span class="text">跳至</span>
            <el-input v-model.number="inputValue" size="mini" maxlength="2" class="pagination-input" @input="handleEdit"
              @change="inputValueChange"></el-input>
            <span class="text">页</span>
            <button class="confirm" @click="confirm">确定</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog @close="closeDialog('form')" :title="dialogTotalType == 0 ? '新建回路' : '编辑回路'" :visible.sync="dialogVisible"
      width="751px">
      <div class="dialog-content">
        <div class="form-title"></div>
        <el-form class="details-form" ref="form" :rules="rules" :inline="true" :model="form" label-width="80px">
          <el-form-item label="变配电站:" prop="stationId">
            <el-select v-model="form.stationId" :popper-append-to-body="false" clearable placeholder="请选择场站进行查询">
              <el-option v-for="item in stationData" :key="item.id" :label="item.stationName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回路名称:" prop="loopName">
            <el-input v-model="form.loopName" class="place" placeholder="请输入回路名称"></el-input>
          </el-form-item>
          <el-form-item label="回路编号:" prop="loopNumber">
            <el-input v-model="form.loopNumber" class="place" placeholder="请输入回路编号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="上级回路:">
            <el-select v-model="detailsData.status" :popper-append-to-body="false" clearable placeholder="请选择上级回路">
              <el-option label="回路1" value="0"></el-option>
              <el-option label="回路2" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否进线:">
            <el-select v-model="form.lineFlage" :popper-append-to-body="false" clearable placeholder="请选择是否进线">
              <el-option label="否" :value="2"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="仪表:" prop="yb">
            <el-select v-model="detailsData.status" :popper-append-to-body="false" clearable placeholder="请选择仪表">
              <el-option label="仪表1" value="0"></el-option>
              <el-option label="仪表2" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="仪表编号:">
            <el-input v-model="detailsData.userName" class="place" placeholder="请输入仪表编号"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDialogVisible('form')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑回路" :visible.sync="dialogVisible2" width="751px">
      <div class="dialog-content">
        <div class="form-title"></div>
        <el-form class="details-form" ref="form" :rules="rules" :inline="true" :model="form" label-width="80px">
          <el-form-item label="变配电站:" prop="bpdz">
            <el-select v-model="form.bpdz" :popper-append-to-body="false" clearable placeholder="请选择场站进行查询">
              <el-option label="电站1" value="0"></el-option>
              <el-option label="电站2" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回路名称:" prop="hlmc">
            <el-input v-model="form.hlmc" class="place" placeholder="请输入回路名称"></el-input>
          </el-form-item>
          <el-form-item label="回路编号:" prop="hlbh">
            <el-input v-model="detailsData.userName" class="place" placeholder="请输入回路编号"></el-input>
          </el-form-item>
          <el-form-item label="上级回路:">
            <el-select v-model="detailsData.status" :popper-append-to-body="false" clearable placeholder="请选择上级回路">
              <el-option label="回路1" value="0"></el-option>
              <el-option label="回路2" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否进线:">
            <el-select v-model="detailsData.status" :popper-append-to-body="false" clearable placeholder="请选择是否进线">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仪表:" prop="yb">
            <el-select v-model="detailsData.status" :popper-append-to-body="false" clearable placeholder="请选择仪表">
              <el-option label="仪表1" value="0"></el-option>
              <el-option label="仪表2" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="仪表编号:">
            <el-input v-model="detailsData.userName" class="place" placeholder="请输入仪表编号"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看回路" :visible.sync="dialogVisible3" width="751px">
      <div class="dialog-content">
        <div class="form-title"></div>
        <el-form class="details-form" ref="form" :rules="rules" :inline="true" :model="form" label-width="80px">
          <el-form-item label="变配电站:">
            <el-select :disabled="true" v-model="form.stationId" :popper-append-to-body="false" clearable
              placeholder="请选择场站进行查询">
              <el-option v-for="item in stationData" :key="item.id" :label="item.stationName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回路名称:">
            <el-input v-model="form.loopName" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="回路编号:">
            <el-input v-model="form.loopNumber" :readonly="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="上级回路:">
            <el-input v-model="form.sjhl" readonly="true"></el-input>
          </el-form-item> -->
          <el-form-item label="是否进线:">
            <el-select :disabled="true" v-model="form.lineFlage" :popper-append-to-body="false" clearable
              placeholder="请选择是否进线">
              <el-option label="否" :value="2"></el-option>
              <el-option label="是" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="仪表:">
            <el-input v-model="form.yb" readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="仪表编号:">
            <el-input v-model="form.ybbh" readonly="true"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="删除" :visible.sync="deleteVisible" width="436px">
      <div class="delete">确定要删除该回路信息吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteInspectionForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { inspectionFormApi } from "@/api/inspectionForm.js";
import { stationName, getList, loopInfoSave, loopInfoUpdate, loopInfoBatchRemove } from "@/api/eios.js"
export default {
  name: "",
  data() {
    return {
      dataLoading: false,
      tableData: [],
      requestParam: {
        pageNum: 1,
        pageSize: 10,
        // stationId: "",
        loopNumber: "",
        loopName: "",
      },
      form: {
        stationId: '',
        loopName: '',
        loopNumber: '',
        lineFlage: ''
      },
      rules: {
        stationId: [
          { required: true, message: '请选择变配电站', trigger: 'change' }
        ],
        loopName: [
          { required: true, message: '请输入回路名称', trigger: 'blur' },
        ],
        loopNumber: [
          { required: true, message: '请输入回路编号', trigger: 'blur' },
        ],
        lineFlage: [
          { required: true, message: '请选择仪表', trigger: 'change' }
        ]
      },
      total: 0,
      inputValue: "",
      viewVisible: false,
      deleteVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      detailsData: {},
      id: "",
      inspectionItem: [],
      selected: "",
      stationData: [],
      dialogTotalType: 0
    };
  },
  created() {
    this.$store.commit('increment', '系统设置')
    this.$store.commit('selectChild', '监测回路')
    this.dataLoading = false
    // this.getList()
  },

  mounted() {
    this.queryStationName()
    this.queryOperation()
  },

  methods: {

    isOverflow(content) {
      const lineHeight = 16;
      const numLines = Math.ceil(content.length / 42); // 每行大概显示42个字符
      // console.log("====>",numLines);
      return numLines >= 3;
    },
    //序号
    getIndex(index) {
      return (this.requestParam.pageNum - 1) * this.requestParam.pageSize + index + 1;
    },
    closeDialog(form) {
      this.form = this.$options.data().form
      this.$refs[form].resetFields();
    },
    //新增
    addDialogVisible(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let func = this.dialogTotalType == 0 ? loopInfoSave(this.form) : loopInfoUpdate(this.form)
          func.then(res => {
            if (res.code == 200) {
              this.dialogVisible = false
              this.$message({
                message: res.message,
                type: 'success',
                duration: 3000,
                customClass: "messageText",
              });
              this.queryOperation()
            } else {
              this.$message({
                message: res.message,
                type: 'error',
                duration: 3000,
                customClass: "messageText",
              });
            }
          })
        } else {
          return false
        }


      });
    },

    createInspection() {
      this.dialogVisible = true;
      this.dialogTotalType = 0
    },
    editDialog(el) {
      this.id = el.id
      this.dialogVisible = true
      this.form = Object.assign({}, el);
      this.dialogTotalType = 1
    },
    lookDialog(el) {
      this.dialogVisible3 = true
      this.form = Object.assign({}, el);
    },
    deleteDialog(item) {
      this.id = item.id;
      this.deleteVisible = true;
    },
    formQuery() {
      this.requestParam.pageNum = 1;
      this.queryOperation();
    },

    queryOperation() {
      this.dataLoading = true
      getList(this.requestParam).then(res => {
        this.dataLoading = false
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.total
        }
      })


    },
    handleEdit(e) {
      let value = e.replace(/[^\d]/g, ""); // 只能输入数字
      value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      this.inputValue = value
    },
    //页数输入
    inputValueChange() {
      const lastPage = Math.ceil(this.total / this.requestParam.pageSize);
      if (this.inputValue < 1) {
        this.inputValue = 1;
      } else {
        this.inputValue =
          this.inputValue < lastPage ? this.inputValue : lastPage;
      }
    },
    //首页
    homePage() {
      this.requestParam.pageNum = 1;
      this.queryOperation();
    },
    //尾页
    tailPage() {
      const lastPage = Math.ceil(this.total / this.requestParam.pageSize);
      this.requestParam.pageNum = lastPage;
      this.queryOperation();
    },
    confirm() {
      this.requestParam.pageNum = this.inputValue;
      this.queryOperation();
    },
    changeSize(pageSize) {
      this.requestParam.pageSize = pageSize;
      this.queryOperation();
    },
    changeCurrent(pageNum) {
      this.requestParam.pageNum = pageNum;
      this.queryOperation();
    },
    queryInspectionItem() {
      inspectionFormApi.queryInspectionItem().then((res) => {
        if (res.code === 200) {
          this.inspectionItem = res.data;
          console.log(this.inspectionItem);
        }
      });
    },
    queryInspectionForm() {
      inspectionFormApi.queryInspectionForm(this.requestParam).then((res) => {
        if (res.code === 200) {
          // this.tableData = res.data;
          this.total = res.total;
        }
      });
    },
    queryStationName() {
      stationName().then((res) => {
        if (res.code === 200) {
          this.stationData = res.data;
          this.total = res.total
        }
      });
    },
    //删除
    deleteInspectionForm() {
      loopInfoBatchRemove(this.id).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success",
            duration: 3000,
            customClass: "messageText",
          });
          this.deleteVisible = false;
          this.queryOperation();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000,
            customClass: "messageText",
          });
        }
      });
    },
  },
  watch: {
    // 如果只需要监听对象中的一个属性值，则可以做以下优化：使用字符串的形式监听对象属性：
    "requestParam.pageNum": {
      // 执行方法
      handler(newValue, oldValue) {
        this.inputValue = newValue;
      },
      deep: true, // 深度监听
      immediate: true, // 第一次改变就执行
    },
  },
};
</script>
<style scoped>
#inspection-form {
  width: 100%;
  min-height: 781px;
  background: url("../../assets/images/rightBG.png") no-repeat;
  background-position: left left;
  background-size: cover;
  font-size: 16px;
}

.main {
  width: 100%;
  padding: 20px 26px 28px 25px;
  box-sizing: border-box;
}

.title {
  font-size: 16px;
  font-family: "Arial", sans-serif;
  color: #e8f4ff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.title img {
  width: 20px;
  height: 20px;
}

.title span {
  font-size: 16px;
  font-family: "Arial", sans-serif;
  color: #e8f4ff;
  margin-left: 10px;
}

/* 查询表单 */
.query-form {
  padding: 16px 20px;
  background-color: #061b45;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.query-button {
  display: flex;
  /* justify-content: space-between; */
}

.query-button :deep() .el-button {
  height: 35px;
  padding: 0 20px;
  background-color: #176ad2;
  text-align: center;
  line-height: 35px;
  font-size: 12px;
  color: #e8f4ff;
  border: 0;
}

.form :deep() .el-form-item {
  margin: 0 16px 12px 0;
}

.form :deep().el-form-item__label {
  width: 61px;
  padding-right: 0;
  color: #e8f4ff;
  font-size: 12px;
  text-align: left;
}

/* input */
.form :deep() .el-input .el-input__inner {
  height: 35px;
  width: 180px;
  background-color: #061b45;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;
}

/* :deep() .el-input .el-input__inner{
  color:#aed6ff !important;
} */
.form :deep() .el-input input::placeholder {
  font-size: 12px;
  color: #6180a8;
}

:deep() .el-input input::placeholder {
  font-size: 12px;
  color: #6180a8;
}

/* 下拉选择框 */
.el-select>>>.el-select-dropdown {
  background: #041c4c !important;
  border: 1px solid #09295b;
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.hover {
  background: #041c4c !important;
  color: #fff;
}

::v-deep .el-select-dropdown__item {
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.selected {
  color: #fff;
}

.el-select ::placeholder {
  color: #6180a8;
}

.el-select {
  width: 100%;
}

/* 表格 */
/* 设置表头的背景颜色 */
.table :deep() thead th {
  background-color: #09224b;
  color: #e8f4ff;
  font-size: 14px;
}

.table :deep() tbody tr {
  font-size: 12px;
  color: #aed6ff;
}

/* 设置表格内的背景颜色 */
::v-deep.el-table tbody tr:nth-child(odd) {
  background-color: #071734;
}

::v-deep.el-table tbody tr:nth-child(even) {
  background-color: #071734;
}

::v-deep.el-table {
  border: 2px solid #081f42 !important;
  position: relative;
}

::v-deep.el-table th {
  border: 1px solid #09234e !important;
}

::v-deep.el-table td {
  border: 1px solid #0d2247 !important;
}

.table ::v-deep .el-table__body tr:hover>td {
  background-color: #081f42 !important;
}

::v-deep .el-table::before {
  height: 0px;
}

::v-deep .el-table__fixed-right::before {
  height: 0px;
}

::v-deep .el-table__body tr.hover-row>td.el-table__cell {
  background-color: #081f42 !important;
}

/* 暂无数据 */
::v-deep .el-table__body-wrapper {
  background: #071734;
}

::v-deep .el-table__empty-text {
  color: aliceblue;
  line-height: 150px;
}

.response-message {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.operate span {
  margin: 0 3px;
}

.tooltip {
  text-align: center;
}

/* 分页 */
.pagination {
  margin-top: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination :deep() .el-pagination {
  padding-left: 0;
}

.home-page,
.tail-page {
  width: 60px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Arial", sans-serif;
  color: #92b5da;
  text-align: center;
  line-height: 30px;
  margin-right: 5px;
}

.home-page:hover,
.tail-page:hover {
  background-color: #176ad2;
  box-sizing: border-box;
  color: #ffffff;
}

.home-page:checked,
.tail-page:checked {
  background-color: #176ad2;
  box-sizing: border-box;
  color: #ffffff;
}

.el-pagination>>>.btn-prev,
.el-pagination>>>.btn-next {
  width: 60px;
  height: 30px;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 30px;
  padding: 0;
  text-align: center;
}

.el-pagination>>>.el-pager li {
  width: 35px;
  height: 30px;
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.jump-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-input {
  height: 30px;
  width: 35px;
  margin: 0 10px;
}

.pagination-input>>>.el-input__inner {
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #0b2653;
  padding: 0;
  text-align: center;
  color: #92b5da;
}

.pagination :deep().el-select .el-input__inner {
  height: 30px;

  color: #92b5da;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
}

.pagination :deep() .el-pagination__sizes {
  margin-right: 0;
}

.jump-pagination .text {
  color: #92b5da;
  line-height: 30px;
}

.confirm {
  width: 60px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid rgba(228, 228, 228, 0);
  background-color: #176ad2;
  font-family: "微软雅黑", sans-serif;
  color: #d7d7d7;
  text-align: center;
  line-height: 30px;
  padding: 0;
  margin-left: 5px;
}

/* 弹窗 */
::v-deep .el-dialog {
  background-color: #071734;
}

::v-deep .el-dialog .el-dialog__header {
  background-color: #05153a;
  border-bottom: 1px solid #09295b;
}

::v-deep .el-dialog__title {
  font-size: 16px;
  color: #c9d4f1;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .el-dialog__footer {
  padding-top: 0;
}

.form-title {
  font-family: "Arial Bold", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  color: #c9d4f1;
  font-size: 16px;
  margin-bottom: 16px;
}

.dialog-content {
  margin: 18px 50px 0 47px;
}

.details-form :deep().el-form-item__label {
  width: 69px;
  color: #c9d4f1;
  font-size: 12px;
  text-align: left;
  margin-right: 28px;
}

.details-form :deep() .el-input .el-input__inner {
  width: 447px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: rgba(255, 255, 255, 0);
}

.interval {
  width: 654px;
  height: 1px;
  background-color: #06224e;
  margin-bottom: 16px;
}

.details-form .default-inspection :deep() .el-input .el-input__inner {
  width: 651px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: rgba(255, 255, 255, 0);
}

.details-form .selected-inspection:deep() .el-input .el-input__inner {
  width: 651px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: #041c4c;
}

.default-inspection :deep() .el-select-dropdown__item {
  height: 35px;
  background-color: rgba(255, 255, 255, 0);
  border-bottom: 1px solid #06224e;
  box-sizing: border-box;
  font-size: 12px;
  color: #aed6ff;
  font-weight: 300;
}

.details-form :deep() .el-select-dropdown__item {

  display: flex;
  justify-content: space-between;
}

::v-deep .el-popper[x-placement^="bottom"] .popper__arrow::after {
  top: 0;
  border-bottom-color: #041c4c;
}

.delete {
  font-size: 16px;
  font-weight: 700;
  color: #c9d4f1;
  margin: 42px 0 64px 39px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #000;
}

.dialog-footer button {
  width: 106px;
  height: 36px;
  background: #2142a1;
  border: 0;
  color: #ffffff;
  font-size: 13px;
}

.tooltip {
  max-width: 600px;
  /* 设置最大宽度 */
  line-height: 20px;
}

/* tableLoading字体设置 */
::v-deep .el-icon-loading {
  font-size: 18px;

}

::v-deep .el-loading-text {
  font-size: 18px;

}

.tableText {
  font-size: 16px;
  color: #aed6ff;

}
</style>
